import React from 'react';

function SecurityMetricsIcon(props) {
	return (
		<a 
			href="//www.securitymetrics.com/site_certificate?id=1770479&tk=0604edad39ff76612f5c446a481858e6"
			target="_blank" 
			rel="noopener noreferrer"
		>
			<img 
				src="https://www.securitymetrics.com/static/apps/super/assets/img/Credit_Card_Safe_light.png"
				alt="" 
				width="100px"
				className="border"
			/>
		</a>			
	);
}

export default SecurityMetricsIcon;



// WEBPACK FOOTER //
// ./src/components/billing-form/SecurityMetricsIcon.js